module.exports = __webpack_public_path__ + "static/media/2.1032b94e.jpg";